// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login {
  display: flex;
  justify-content: center;
  align-items: center;
}
.login .card {
  box-shadow: 6px 7px 10px rgba(0, 0, 0, 0.3);
  border: 0px solid #c8ced3;
  border-radius: 1.25rem;
}
.login .logo img {
  width: 80%;
}

.mat-form-field {
  margin-left: 0 !important;
}

.language-position {
  margin-left: 4px;
  margin-bottom: 4em !important;
}

:host #select-language ::ng-deep .mat-form-field {
  margin-left: 0 !important;
}

.mat-dialog-content {
  overflow-x: auto !important;
  overflow-y: auto !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/login/mynamirialbinding/mynamirialbinding.component.scss"],"names":[],"mappings":"AAAA;EAEI,aAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;AAGI;EACE,2CAAA;EACA,yBAAA;EACA,sBAAA;AADN;AAII;EACE,UAAA;AAFN;;AAME;EACE,yBAAA;AAHJ;;AAME;EACE,gBAAA;EACA,6BAAA;AAHJ;;AAQM;EACE,yBAAA;AALR;;AAUE;EAEE,2BAAA;EACA,2BAAA;AARJ","sourcesContent":[".login {\r\n    \r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n  \r\n    .card {\r\n      box-shadow: 6px 7px 10px rgba(0, 0, 0, 0.3);\r\n      border: 0px solid #c8ced3;\r\n      border-radius: 1.25rem;\r\n    }\r\n  \r\n    .logo img {\r\n      width: 80%;\r\n    }\r\n  }\r\n  \r\n  .mat-form-field {\r\n    margin-left: 0 !important;\r\n  }\r\n  \r\n  .language-position {\r\n    margin-left: 4px;\r\n    margin-bottom: 4em !important;\r\n  }\r\n  \r\n  :host {\r\n    #select-language ::ng-deep {\r\n      .mat-form-field {\r\n        margin-left: 0 !important;\r\n      }\r\n    }\r\n  }\r\n\r\n  .mat-dialog-content {         \r\n    \r\n    overflow-x: auto  !important;\r\n    overflow-y: auto  !important;\r\n\r\n    \r\n    \r\n  }\r\n\r\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
